/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSolvV2ConvertiblePriceOracleManager extends Contract<ITestSolvV2ConvertiblePriceOracleManager> {
  _setVoucherOracle: Send<(_voucher: AddressLike, _oracle: AddressLike) => void, ITestSolvV2ConvertiblePriceOracleManager>
  '_setVoucherOracle(address,address)': Send<(_voucher: AddressLike, _oracle: AddressLike) => void, ITestSolvV2ConvertiblePriceOracleManager>
  getOracle: Call<(_voucher: AddressLike) => string, ITestSolvV2ConvertiblePriceOracleManager>
  'getOracle(address)': Call<(_voucher: AddressLike) => string, ITestSolvV2ConvertiblePriceOracleManager>
  getPriceOfMaturity: Call<(_voucher: AddressLike, _maturity: BigNumberish) => BigNumber, ITestSolvV2ConvertiblePriceOracleManager>
  'getPriceOfMaturity(address,uint64)': Call<(_voucher: AddressLike, _maturity: BigNumberish) => BigNumber, ITestSolvV2ConvertiblePriceOracleManager>
}

let ITestSolvV2ConvertiblePriceOracleManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSolvV2ConvertiblePriceOracleManagerBytecode = '0x';
}

// prettier-ignore
export const ITestSolvV2ConvertiblePriceOracleManager = contract<ITestSolvV2ConvertiblePriceOracleManager>(ITestSolvV2ConvertiblePriceOracleManagerBytecode)`
  function _setVoucherOracle(address _voucher, address _oracle)
  function getOracle(address _voucher) view returns (address oracle_)
  function getPriceOfMaturity(address _voucher, uint64 _maturity) view returns (int256 price_)
`;